import React from 'react';
import { Field } from 'redux-form';
import { FormGroup, Label } from 'reactstrap';

import Repeater from '../../../system/fields/Repeater';
import * as validations from '../../../system/utils/Validation';
import TextInput from '../../../system/fields/TextInput';
import Select from '../../../system/fields/SelectDropdown';

class TravellerWrapper extends React.Component {
  constructor(props, traveller, index, fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: true };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (
      <Repeater key={this.props.index}>
        <div className="toolbar">
          <i
            className="far fa-trash-alt"
            onClick={() => this.props.fields.remove(this.props.index)}
          />
        </div>
        <div className="row top-field">
          <FormGroup className="col-12 col-sm-6">
            <Label>First Name</Label>
            <Field name={`${this.props.traveller}.first_name`} type="text" component={TextInput} />
          </FormGroup>
          <FormGroup className="col-12 col-sm-6">
            <Label>Last Name</Label>
            <Field name={`${this.props.traveller}.last_name`} type="text" component={TextInput} />
          </FormGroup>
          <FormGroup className="col-12 col-sm-6">
            <Label>Gender</Label>
            <Field
              name={`${this.props.traveller}.gender`}
              component={Select}
              labelKey={'value'}
              valueKey={'value'}
              clearable={false}
              placeholder="Gender"
              options={[{ id: 1, value: 'Male' }, { id: 2, value: 'Female' }]}
              style={{ width: 100, clear: 'both' }}
              validate={validations.required}
            />
          </FormGroup>
          <FormGroup className="col-12 mb-0">
            <Label>Date of Birth</Label>
          </FormGroup>
          <FormGroup className="col-4">
            <Label>Date</Label>
            <Field name={`${this.props.traveller}.date`} type="text" component={TextInput} />
          </FormGroup>
          <FormGroup className="col-4">
            <Label>Month</Label>
            <Field name={`${this.props.traveller}.month`} type="text" component={TextInput} />
          </FormGroup>
          <FormGroup className="col-4">
            <Label>Year</Label>
            <Field name={`${this.props.traveller}.year`} type="text" component={TextInput} />
          </FormGroup>
        </div>
      </Repeater>
    );
  }
}

export default TravellerWrapper;



// WEBPACK FOOTER //
// ./src/containers/Bookings/components/TravellerWrapper.jsx